var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 7,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C13.9174 22 16.7153 20.8411 18.7782 18.7782C20.8411 16.7153 22 13.9174 22 11C22 8.08262 20.8411 5.28473 18.7782 3.22183C16.7153 1.15893 13.9174 0 11 0C8.08262 0 5.28473 1.15893 3.22183 3.22183C1.15893 5.28473 0 8.08262 0 11C0 13.9174 1.15893 16.7153 3.22183 18.7782C5.28473 20.8411 8.08262 22 11 22ZM7.51953 7.51953C7.92344 7.11562 8.57656 7.11562 8.97617 7.51953L10.9957 9.53906L13.0152 7.51953C13.4191 7.11562 14.0723 7.11562 14.4719 7.51953C14.8715 7.92344 14.8758 8.57656 14.4719 8.97617L12.4523 10.9957L14.4719 13.0152C14.8758 13.4191 14.8758 14.0723 14.4719 14.4719C14.068 14.8715 13.4148 14.8758 13.0152 14.4719L10.9957 12.4523L8.97617 14.4719C8.57227 14.8758 7.91914 14.8758 7.51953 14.4719C7.11992 14.068 7.11562 13.4148 7.51953 13.0152L9.53906 10.9957L7.51953 8.97617C7.11562 8.57227 7.11562 7.91914 7.51953 7.51953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosseIcon);
export default __webpack_public_path__ + "static/media/closse-icon.c96070fe2152433e3e4f5c18ad417cde.svg";
export { ForwardRef as ReactComponent };